import React, { ErrorInfo, ReactNode } from 'react';
import ErrorPageComp from '../../pages/_error';
import { captureException } from '@sentry/nextjs';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}
class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // You can also log the error to an error reporting service
    captureException(error);
    console.error(error, errorInfo);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return <ErrorPageComp statusCode={500} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
